/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import '../css/footer.css';
import {
	Modal, Card, Col, Row, Container, Collapse
} from 'react-bootstrap';
import renderHTML from 'react-render-html';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import TranslationHelper from '../common/TranslationHelper';

class Footer extends React.Component {
	// eslint-disable-next-line react/static-property-placement
	static propTypes = {
		cookies: instanceOf(Cookies).isRequired
	};

	constructor(props) {
		super(props);

		const { cookies } = props;

		this.state = {
			showTerms: false,
			showPrivacy: false,
			showOtherPolicies: false,
			showCookie: !cookies.get('accept_cookie'),
			showFooter: false,
		};

		this.modalTermsToggle = this.modalTermsToggle.bind(this);
		this.modalPrivacyToggle = this.modalPrivacyToggle.bind(this);
		this.modalOtherPolicesToggle = this.modalOtherPolicesToggle.bind(this);
		this.handleFooterClick = this.handleFooterClick.bind(this);
	}

	// eslint-disable-next-line react/sort-comp
	modalTermsToggle() {
		this.setState({
			showTerms: !this.state.showTerms
		});
	}

	modalPrivacyToggle() {
		this.setState({
			showPrivacy: !this.state.showPrivacy
		});
	}

	modalOtherPolicesToggle() {
		this.setState({
			showOtherPolicies: !this.state.showOtherPolicies
		});
	}

	handleFooterClick() {
		this.setState({
			showFooter: !this.state.showFooter,
		});
	}

	handleAcceptCookie(props) {
		const { cookies } = props;
		const { hostname } = window.location;
		const currentHref = window.location.href.split(/\/+/);
		const domain = currentHref[1].substring(currentHref[1].indexOf('.'), currentHref[1].length);
		this.setState({
			showCookie: false
		}, () => {
			cookies.set('accept_cookie', true, {
				path: '/',
				domain: hostname === 'localhost' ? hostname : domain
			});
		});
	}

	render() {
		// console.log('about to display footer');
		const cookie1 = TranslationHelper.getValue('customer_account.footer.thisWebsiteUsingCookie.part1');
		const cookie2 = TranslationHelper.getValue('customer_account.footer.thisWebsiteUsingCookie.part2');
		const cookie3 = TranslationHelper.getValue('customer_account.footer.thisWebsiteUsingCookie.part3');
		const cookie4 = TranslationHelper.getValue('customer_account.footer.thisWebsiteUsingCookie.part4');
		// const link = "<strong><a href=\"http://www.idyaflow.com\">IdyaFlow</a></strong>";
		let copyrightRight = '';
		// if(this.props.subscription && this.props.subscription !== 'IDYAFLOW_PLUS'){
		if (this.props.subscription && this.props.subscription.length && this.props.subscription !== 'IDYAFLOW_PLUS') {
			copyrightRight = (
				<div className="col-xs-5 copyrightLinkRight">
					Powered by
					{' '}
					<a href="https://www.idyaflow.com" target="_blank" rel="noopener noreferrer">IdyaFlow Inc.</a>
				</div>
			);
		}
		const { address } = this.props.company;
		const finalAddress = this.props.supportedCountries
		&& this.props.supportedCountries.includes('JPN')
			? `${address.zip}${address.state}${address.city}${address.town}${address.street}`
			: `${address.street} ${address.city}, ${address.state}, ${address.country}, ${address.zip}`;
		// console.log('about to display footer');
		return (
			<div id="footer" className="footer">
				{this.state.showCookie && cookie1 !== 'customer_account.footer.thisWebsiteUsingCookie.part1' && (
					<div className="cookieUsed">
						{cookie1}
&nbsp;
						<a target="blank" href="/terms-and-conditions">
							{cookie2}
						</a>
&nbsp;
						{cookie3}
&nbsp;
						<a href="#/" onClick={(e) => { e.preventDefault(); this.handleAcceptCookie(this.props); }}>
							<u>{cookie4}</u>
						</a>
						<button
							type="button"
							className="btn"
							onClick={() => { this.handleAcceptCookie(this.props); }}
						>
							X
						</button>
					</div>
				)}
				<Card style={{ border: '0', }}>
					<Collapse in={this.state.showFooter}>
						<div>
							<Card.Body style={{ background: '#3e4453', padding: '8px' }}>
								<Container id="moreInfo">
									<Row>
										<Col xs={12} md={4}>
											<h4>
												{
													TranslationHelper
														.getValue('customer_account.footer.aboutUs')
														.replace('{company}', this.props.company.name)
												}
											</h4>
											<ul>
												<li>
													{renderHTML(this.props.company.aboutUs)}
												</li>

											</ul>
										</Col>
										<Col xs={12} md={4}>
											<Row>
												<Col className="social-links">
													<h4>
														{TranslationHelper
															.getValue('customer_account.footer.socialLinks')}
													</h4>
													{(this.props.company.socialLinks
														&& this.props.company.socialLinks.blog
														&& this.props.company.socialLinks.blog !== 'http://')
														? (
															<a href={this.props.company.socialLinks.blog}>
																<i className="fab fa-blogger" />
															</a>
														)
														: ''}
													{(this.props.company.socialLinks
														&& this.props.company.socialLinks.facebook
														&& this.props.company.socialLinks.facebook !== 'http://')
														? (
															<a href={this.props.company.socialLinks.facebook}>
																<i className="fab fa-facebook" />
															</a>
														)
														: ''}
													{(this.props.company.socialLinks
														&& this.props.company.socialLinks.twitter
														&& this.props.company.socialLinks.twitter !== 'http://')
														? (
															<a href={this.props.company.socialLinks.twitter}>
																<i className="fab fa-twitter" />
															</a>
														)
														: ''}
													{(this.props.company.socialLinks
														&& this.props.company.socialLinks.instagram
														&& this.props.company.socialLinks.instagram !== 'http://')
														? (
															<a href={this.props.company.socialLinks.instagram}>
																<i className="fab fa-instagram" />
															</a>
														)
														: ''}
													{(this.props.company.socialLinks
														&& this.props.company.socialLinks.linkedin
														&& this.props.company.socialLinks.linkedin !== 'http://')
														? (
															<a href={this.props.company.socialLinks.linkedin}>
																<i className="fab fa-linkedin" />
															</a>
														)
														: ''}
												</Col>
											</Row>
											<br />
											<span>
												<a
													href="#modal-dialog-TermsandConditions"
													data-toggle="modal"
													style={{ color: '#9da5b9' }}
													onClick={this.modalTermsToggle}
												>
													{TranslationHelper
														.getValue('customer_account.footer.termsAndConditions')}
												</a>
											</span>
											<br />
											<span>
												<a
													href="#modal-dialog-PrivacyPolicies"
													data-toggle="modal"
													style={{ color: '#9da5b9' }}
													onClick={this.modalPrivacyToggle}
												>
													{TranslationHelper
														.getValue('customer_account.footer.privacyPolicies')}
												</a>
											</span>
											<br />
											<span>
												<a
													href="#modal-dialog-PrivacyPolicies"
													data-toggle="modal"
													style={{ color: '#9da5b9' }}
													onClick={this.modalOtherPolicesToggle}
												>
													{TranslationHelper
														.getValue('customer_account.footer.otherPolicies')}
												</a>
											</span>

										</Col>
										<Col xs={12} md={4}>
											<h4>
												{TranslationHelper.getValue('customer_account.footer.contact')}
											</h4>
											<ul style={{ display: 'flex', flexDirection: 'column' }}>
												<li className="col-xs-12">
													<i className="fa fa-building" />
													{finalAddress}
												</li>
												<li className="col-xs-12">
													<i
														className="fa fa-phone"
													/>
													&nbsp;
													<a
														style={{ fontSize: '14px', padding: '0', }}
														href={`tel:${this.props.company.phone}`}
													>
														{this.props.company.phone}
													</a>
												</li>
												<li className="col-xs-12">
													<i
														className="fa fa-envelope"
													/>
													&nbsp;
													<a
														style={{ fontSize: '14px', padding: '0', }}
														href={`mailto:${this.props.email}`}
													>
														{this.props.email}
													</a>
												</li>
											</ul>
										</Col>
									</Row>
								</Container>
							</Card.Body>

						</div>
					</Collapse>

					<Card.Body className="copyright" style={{ background: '#313643' }} onClick={this.handleFooterClick}>
						<Col className="pull-left">
							{
								(this.props.policies.CopyrightLink && this.props.policies.CopyrightLink.value.length)
									? (
										<div className="col-xs-5 copyrightLink">
											{renderHTML(this.props.policies.CopyrightLink.value)}
										</div>
									)
									:							(
										<div className="col-xs-5 copyrightLink" />
									)
							}
						</Col>
						<Col>
							<div id="hamburger" className="text-center">
								<i className="far fa-bars" />
							</div>
						</Col>
						<Col className="pull-right">
							{this.props.subscription !== 'IDYAFLOW_PLUS' ? copyrightRight : null}
						</Col>
					</Card.Body>
				</Card>

				<Modal show={this.state.showTerms} onHide={this.modalTermsToggle} style={{ opacity: 1 }}>
					<Modal.Header className="bg-footer" closeButton closeLabel>
						<Modal.Title>
							{(this.props.policies.TermsandConditions)
								? this.props.policies.TermsandConditions.name
								: ''}
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Card>
							<Card.Body>
								{renderHTML((this.props.policies.TermsandConditions)
									? this.props.policies.TermsandConditions.value
									: '')}
							</Card.Body>
						</Card>
					</Modal.Body>
				</Modal>

				<Modal show={this.state.showPrivacy} onHide={this.modalPrivacyToggle} style={{ opacity: 1 }}>
					<Modal.Header className="bg-footer" closeButton closeLabel>
						<Modal.Title>
							{(this.props.policies.PrivacyPolicies)
								? this.props.policies.PrivacyPolicies.name
								: ''}
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Card>
							<Card.Body>
								{renderHTML((this.props.policies.PrivacyPolicies)
									? this.props.policies.PrivacyPolicies.value
									: '')}
							</Card.Body>
						</Card>
					</Modal.Body>
				</Modal>

				<Modal show={this.state.showOtherPolicies} onHide={this.modalOtherPolicesToggle} style={{ opacity: 1 }}>
					<Modal.Header className="bg-footer" closeButton closeLabel>
						<Modal.Title>
							{(this.props.policies.OtherPolicies)
								? this.props.policies.OtherPolicies.name
								: ''}
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Card>
							<Card.Body>
								{renderHTML((this.props.policies.OtherPolicies)
									? this.props.policies.OtherPolicies.value
									: '')}
							</Card.Body>
						</Card>
					</Modal.Body>
				</Modal>
			</div>
		);
	}
}

export default withCookies(Footer);
